import { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "../../components/Modal";
import UpdateFavouritesHeader from "./components/UpgradeFavouriteHeader";
import {
  CHANGE_NAME_VIEW,
  MARKETS_VIEW,
  UPDATE_FAVOURITES_VIEW,
} from "../../constants";
import { FavouritesList } from "./components/FavouritesList";
import { ChangeName } from "./components/ChangeName";

const FAVOURITE_VIEWS = new Map([
  [UPDATE_FAVOURITES_VIEW, FavouritesList],
  [CHANGE_NAME_VIEW, ChangeName],
]);

const FAVOURITE_TITLE = new Map([
  [UPDATE_FAVOURITES_VIEW, "Add to Favourites"],
  [CHANGE_NAME_VIEW, "Change Name"],
]);

function UpdateFavourites() {
  const { storedFavourites } = useSelector((state) => state.filter);
  const { activeView } = useSelector((state) => state.view);
  const [selectedFavourite, setSelectedFavourite] = useState("");

  const markets = storedFavourites.filter(
    (favourite) => favourite.type === MARKETS_VIEW
  );

  if (activeView !== UPDATE_FAVOURITES_VIEW && activeView !== CHANGE_NAME_VIEW)
    return null;

  const FavouriteView = FAVOURITE_VIEWS.get(activeView);

  return (
    <Modal>
      <UpdateFavouritesHeader selectedFavourite={selectedFavourite}>
        {FAVOURITE_TITLE.get(activeView)}
      </UpdateFavouritesHeader>
      {FavouriteView ? (
        <FavouriteView
          markets={markets}
          selectedFavourite={selectedFavourite}
          setSelectedFavourite={setSelectedFavourite}
        />
      ) : null}
    </Modal>
  );
}

export default UpdateFavourites;
